"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactHours = _interopRequireDefault(require("react-hours"));
var _OpeningHoursSelector = require("./OpeningHoursSelector.style");
var _styledComponents = require("styled-components");
var _theme = require("../utils/theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OpeningHoursSelector = function OpeningHoursSelector(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    initialValue = _ref.initialValue,
    _onChange = _ref.onChange;
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_OpeningHoursSelector.OHRow, null, /*#__PURE__*/_react["default"].createElement(_OpeningHoursSelector.OHColumn, null, /*#__PURE__*/_react["default"].createElement(_reactHours["default"], {
    locale: "en-US",
    theme: theme,
    value: value,
    onChange: function onChange(str) {
      setValue(str);
      _onChange(str);
    }
  }))));
};
var _default = exports["default"] = OpeningHoursSelector;